import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";
import { ErrorModal } from '@futures-platform/ui'
import Markdown from "react-markdown";
import _ from "lodash";
import DatePicker from "react-datepicker";
import HistoryEditor from "../Voting/HistoryEditor";
import {
  requestTranslation,
  getAvailableLanguages,
  getLanguage,
} from "@futures-platform/i18n";
import { useEditableGroups } from "@futures-platform/hooks";
import { Formik } from "formik";
import { map, differenceBy, capitalize, uniqBy } from "lodash-es";
import Select from "react-select";
import styled from "styled-components";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import PhenomenaSelector from "./PhenomenaSelector";
import PhenomenaTimingEditor from "./PhenomenaTimingEditor";
// import PhenomenonTypeRadiobox from "./PhenomenonTypeRadiobox";
import {PhenomenonTypeRadiobox} from '@futures-platform/ui'
import PhenomenaLinks from "./PhenomenaLinks";
import { PhenomenaTagList } from "./PhenomenaTagList";
import { mdiTagPlusOutline, mdiTagPlus } from "@mdi/js";
import {
  paddingModalStyles,
  Input,
  Modal,
  SelectImageContainer,
  SelectImageButton,
  SelectImageInput,
  SelectImageInputContainer,
  quillFormats,
  quillModules,
} from "@futures-platform/ui";
import { uploadFile, handleImageUploadIfNeeded } from '@futures-platform/connectors/media-api'
import Icon from "@mdi/react";
import { transformToLegacy } from "@futures-platform/connectors/phenomena-api";
import ReactQuill from "react-quill";
import "./index.css";
import { DataContext } from "../../store/GlobalState";
import { PhenomenaTagSelector } from "./PhenomenaTagSelector";
import {
  getFpTags,
  getGroupTags,
} from "@futures-platform/connectors/tag-service-api";
import useSWR from "swr";
import newsFeedApi from "@futures-platform/connectors/news-feed-api";
import { upsertDocument } from "@futures-platform/connectors/content-service-api";
import { votingApi } from "../../helpers/fetcher";
import {
  getSessionToken,
  getUsername,
} from "@futures-platform/connectors/session";
import InformationModal2 from "../InformationModal/InformationModal";
import { InfoCircle } from "@styled-icons/boxicons-regular";
import ScenariosSelector from "./ScenariosSelector";
import ToggleSwitcher from "./ToggleSwitcher";
import { normalisedTimeFormat } from "../../helpers/helpers";
import { ACTIONS } from "../../store/Actions";
import { validateUrl } from '../../helpers/utils';
const mediaURL = process.env.REACT_APP_MEDIA_API_URL;

const makeGetValue =
  (phenomenon) =>
  (field, defaultValue = null) =>
    phenomenon && phenomenon.hasOwnProperty(field)
      ? phenomenon[field]
      : defaultValue;

const SortableRelatedPhenomena = SortableElement(
  ({ relatedPhenom, onSelect }) => {
    const {
      content: { title },
    } = relatedPhenom;

    return (
      <li
        className="d-flex align-items-center hoverable pt-1 pb-1 bg-white pl-1 pr-1"
        style={{ zIndex: 999, marginBottom: "1px" }}
      >
        <i className="material-icons mr-1" style={{ color: "#666" }}>
          swap_vert
        </i>
        <p className="mb-0">{title}</p>
        <button
          onClick={(e) => {
            e.preventDefault();
            onSelect(relatedPhenom);
          }}
          className="ml-auto material-icons"
          style={{ color: "#006998", flexShrink: 0 }}
        >
          cancel
        </button>
      </li>
    );
  }
);

const SortableRelatedPhenomenaList = SortableContainer(
  ({ relatedPhenomena, onSelect }) => {
    return (
      <ul className="pl-0" style={{ listStyleType: "none" }}>
        {relatedPhenomena.map((relatedPhenom, index) => (
          <SortableRelatedPhenomena
            index={index}
            key={`related-${index}`}
            relatedPhenom={relatedPhenom}
            onSelect={onSelect}
          />
        ))}
      </ul>
    );
  }
);

export const PhenomenonEditForm = ({
  phenomenon: basePhenomenon,
  radar,
  onCancel,
  mutateContentCard,
  gid,
  rid,
  pid,
  relatedScenarios,
  historyData: historyDataProp = [],
  phenomenonData={},
  isFPEditorRole,
  groupNormalized
}) => {
  const historyData = React.useMemo(() => {
    return [...historyDataProp];
  }, [historyDataProp]);
  const [historyDataState, sethistoryDataState] = useState([...historyData]);

  // const historyCountRef = useRef(0)
  // useEffect(() => {
  //   if (!historyDataState?.length && !!historyData?.length && historyCountRef?.current === 0) {
  //     sethistoryDataState(() => [...historyData])
  //     historyCountRef.current = 1
  //   }
  // }, [historyData, historyDataState?.length]);

  const {
    state: { contentData, tags, currentIndexEditingHistory },
    dispatch,
  } = useContext(DataContext);
  const phenomenon = basePhenomenon ? transformToLegacy(basePhenomenon) : null;
  const getValue = makeGetValue(phenomenon);
  const [deletingModalOpen, setDeletingModalOpen] = useState(false);
  const [groupId, setGroupId] = useState(
    radar ? radar.groupId : getValue("group")
  );
  const [isExpandedUpdateRecommended, setisExpandedUpdateRecommended] = useState(false);
  const [iconTaggingSection, seticonTaggingSection] = useState(!!contentData?.tags?.length ? "expand_more": "expand_less");
  const [iconRelatedNodeSection, seticonRelatedNodeSection] =
    useState(!!contentData?.["related-phenomena-data"]?.length ? "expand_more": "expand_less");
  const [iconRelatedNodeSSSection, seticonRelatedNodeSSSection] =
    useState(!!relatedScenarios?.length ? "expand_more" :  "expand_less");
  const [relatedScenariosEditorInfo, setrelatedScenariosEditorInfo] =
    useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [iconNewsFeedSection, seticonNewsFeedSection] = useState(!!contentData?.newsFeeds?.length ? "expand_more" : "expand_less");
  const [links2WebpagesSection, setlinks2WebpagesSection] =
    useState(!!contentData?.links?.length ? "expand_more" : "expand_less");
  const [iconHistorySection, seticonHistorySection] = useState(!!historyDataState?.length ? "expand_more": "expand_less");

  const [isPublic, setIsPublicPhenomenon] = useState(phenomenonData?.isPublic);
  const [mainVideoAndImage, setmainVideoAndImage] = useState((contentData?.media?.video || contentData?.media?.image || contentData?.media?.text) ? "expand_more" : "expand_less");
  const [isTaggingSelectorOpened, setisTaggingSelectorOpened] = useState(false);
  const [fileImg, setfileImg] = useState(null);
  const [step1AnchorEl, setStep1AnchorEl] = useState(null);
  const [step2AnchorEl, setStep2AnchorEl] = useState(null);
  const [isEditHistoryModalOpened, setisEditHistoryModalOpened] =
    useState(false);
  const [isShowDeleteHistoryModal, setisShowDeleteHistoryModal] =
    useState(false);
  const [openPublicPhenomenonModal, setOpenPublicPhenomenonModal] = useState(false);
  const [majorUpdate, setmajorUpdate] = useState({
    isMajorUpdate: false,
    description: "",
  });

  const [step1DescriptionDisplayed, setStep1DescriptionDisplayed] =
    useState(false);
  const onHoverStep1Icon = (event) => {
    setStep1AnchorEl(event.currentTarget);
    setStep1DescriptionDisplayed(true);
  };

  const onLeaveStep1Icon = () => {
    setStep1AnchorEl(null);
    setStep1DescriptionDisplayed(false);
  };

  const [relatedScenariosState, setrelatedScenariosState] =
    useState(relatedScenarios);
  // const { tags: tagList } = useTags(
  //   (contentData?.['phen-data']?.groups[0]) || 0
  // )

  const thisGroupData = React.useMemo(() => {
    return groupNormalized?.find((group) => group?.id === Number(gid));
  }, [groupNormalized, gid]);
  // useEffect(() => {
  //   !!thisGroupData?.publicPhenomena &&  setIsPublicPhenomenon(!!thisGroupData?.publicPhenomena);
  // }, [thisGroupData]);

  const group = React.useMemo(() => {
    return (
      (!!contentData?.["phen-data"] &&
        !!contentData?.["phen-data"]?.groups?.length &&
        contentData?.["phen-data"]?.groups[0]) ||
      gid ||
      0
    );
  }, [contentData, gid]);

  const { data: tagList, mutate: mutateTaglist } = useSWR(
    `get-taglist=${JSON.stringify(group)}`,
    async () => {
      // eslint-disable-next-line no-unused-expressions
      return group === 0
        ? [await getFpTags(), []]
        : await Promise.all([getFpTags(), getGroupTags(group)]);
    }
  );

  const lang = React.useMemo(() => {
    return contentData?.["phen-data"]?.language === "all"
      ? document.querySelector("html").getAttribute("lang") || "en"
      : contentData?.["phen-data"]?.language;
  }, [JSON.stringify(contentData)]);

  // const {
  //     phenomenonTypes,
  //     loading: loadingPhenomenonTypes,
  //     error: errorPhenomenonTypes
  // } = usePhenomenonTypes(groupId)

  const {
    groups,
    loading: loadingGroups,
    error: errorGroups,
    canEditPublic,
  } = useEditableGroups();

  const groupLabel = React.useMemo(() => {
    const group =
      !!groups?.length &&
      groups?.filter((g) => {
        return (
          Number(g?.id) === Number(radar?.group) ||
          (!!radar?.["phen-data"]?.groups?.length
            ? Number(g?.id) === Number(radar?.["phen-data"]?.groups[0])
            : false) ||
          Number(g?.id) === Number(gid)
        );
      });
    return !!group?.length && group[0];
  }, [groups, radar]);

  const handleChangeIconTagSection = () => {
    if (iconTaggingSection === "expand_more")
      seticonTaggingSection(() => `expand_less`);
    else {
      seticonTaggingSection(() => `expand_more`);
    }
  };

  const handleChangeIconRelatedNodesSection = () => {
    if (iconRelatedNodeSection === "expand_more")
      seticonRelatedNodeSection(() => `expand_less`);
    else {
      seticonRelatedNodeSection(() => `expand_more`);
    }
  };
  const handleChangeIconRelatedSSNodesSection = () => {
    if (iconRelatedNodeSSSection === "expand_more")
      seticonRelatedNodeSSSection(() => `expand_less`);
    else {
      seticonRelatedNodeSSSection(() => `expand_more`);
    }
  };
  const handleChangeIconNewsFeedSection = () => {
    if (iconNewsFeedSection === "expand_more")
      seticonNewsFeedSection(() => `expand_less`);
    else {
      seticonNewsFeedSection(() => `expand_more`);
    }
  };
  const handleChangeIconLinks2WebpagesSection = () => {
    if (links2WebpagesSection === "expand_more")
      setlinks2WebpagesSection(() => `expand_less`);
    else {
      setlinks2WebpagesSection(() => `expand_more`);
    }
  };
  const onCloseEditingHistory = () => {
    const dataNew = !!historyDataState?.length ? [...historyDataState] : []
    const dataOld = [...historyDataProp];
    const dataOldWithIndex =!!dataOld?.length ? dataOld[currentIndexEditingHistory] : historyDataState[currentIndexEditingHistory]
    dataNew[currentIndexEditingHistory] = dataOldWithIndex;
    sethistoryDataState(() => [...dataNew]);
    setisEditHistoryModalOpened(false);
  };

  const descriptionEdtingHistoryHandler = (event) => {
    const value = event.target.value;

    const temp = [...historyDataState];
    const temp3 = { ...temp[currentIndexEditingHistory] };

    temp3["description"] = value;
    temp[currentIndexEditingHistory] = { ...temp3 };
    sethistoryDataState(() => [...temp]);
  };
  const descriptionEdtingHistorySanitize = (event) => {
    const value = stripAllHtml(event.target.value);

    const temp = [...historyDataState];
    const temp3 = { ...temp[currentIndexEditingHistory] };

    temp3["description"] = value;
    temp[currentIndexEditingHistory] = { ...temp3 };
    sethistoryDataState(() => [...temp]);
  };
  const userNameEdtingHistoryHandler = (event) => {
    const value = event.target.value;

    const temp = [...historyDataState];
    const temp3 = { ...temp[currentIndexEditingHistory] };

    temp3["editorName"] = value;
    temp[currentIndexEditingHistory] = { ...temp3 };
    sethistoryDataState(() => [...temp]);
  };
  const userNameEdtingHistorySanitize = (event) => {
    const value = stripAllHtml(event.target.value);

    const temp = [...historyDataState];
    const temp3 = { ...temp[currentIndexEditingHistory] };

    temp3["editorName"] = value;
    temp[currentIndexEditingHistory] = { ...temp3 };
    sethistoryDataState(() => [...temp]);
  };
  const handleChangeIconMainVideoImagesSection = () => {
    if (mainVideoAndImage === "expand_more")
      setmainVideoAndImage(() => `expand_less`);
    else {
      setmainVideoAndImage(() => `expand_more`);
    }
  };
  const handleChangeIconHistorySection = () => {
    if (iconHistorySection === "expand_more")
      seticonHistorySection(() => `expand_less`);
    else {
      seticonHistorySection(() => `expand_more`);
    }
  };

  const [iconHistoryMajorUpdateSection, seticonHistoryMajorUpdateSection] =
    useState("expand_less");
  const handleChangeIconHistoryMajorSection = () => {
    if (iconHistoryMajorUpdateSection === "expand_more")
      seticonHistoryMajorUpdateSection(() => `expand_less`);
    else {
      seticonHistoryMajorUpdateSection(() => `expand_more`);
    }
  };

  const [iconPublicPhenomenonSection, seticonPublicPhenomenonSection] =
    useState("expand_less");
  const handleChangeIconPublicPhenomenonSection = () => {
    if (iconHistoryMajorUpdateSection === "expand_more")
      seticonPublicPhenomenonSection(() => `expand_less`);
    else {
      seticonPublicPhenomenonSection(() => `expand_more`);
    }
  };
  const itemsRef = useRef([]);
  // if (itemsRef?.current?.length !== phenomenaList?.length) {
  //   // add or remove refs
  //   itemsRef.current = Array(phenomenaList.length)?.fill().map((_, i) => itemsRef.current[i] || createRef())
  // }

  const setPhenomenaSelectorPosition = (e, i, phenomenon) => {
    // const position = !!itemsRef?.current && !!ReactDOM.findDOMNode(itemsRef.current[i]?.current)  && ReactDOM.findDOMNode(itemsRef.current[i]?.current)?.getBoundingClientRect()
    // setPhenomenonToTag({...phenomenon, position })
  };

  // const phenomenaGroup = !!phenomenaListData?.groups.length &&phenomenaListData?.groups?.filter(phe => {
  //   if ((typeof group === 'number' || typeof group?.value === 'number') ) {
  //     if (phe?.value === group && group !== 0 ) {
  //       return true
  //     }
  //   } else {
  //     return group?.value?.map( (gr) => {
  //       if (phe?.value === gr && gr !== 0) {
  //         return true
  //       }
  //     })
  //   }
  // })
  // const phenomenaGroup2 = _.find(phenomenaListData?.groups, { value:  group })
  // const canEdit = phenomenaGroup ? phenomenaGroup?.canEdit : false
  // const canEdit = !!phenomenaGroup?.length || phenomenaGroup2 ? true : false
  // const freePlan = (highest_group_role === 'free') ? (highest_group_role === 'free') :  (group && group.availableResources && group.availableResources.plan === 'free')
  // let canTag = phenomenonIncludesTagData?.group ? (canEdit && !freePlan) : phenomenaListData?.canEditPublic
  // canTag = !!IsCreateNewContentCard ? false : true
  const loading = loadingGroups;
  const error = errorGroups;

  const [errorsList, setErrorsList] = useState([]);

  const handleClearErrors = () => {
    setErrorsList([]);
    setErrorModalOpen(false);
  };

  if (loading) {
    return <div className="py-5 text-center">Loading...</div>;
  }

  if (error) {
    return <div className="py-5 text-center text-danger">{error?.message}</div>;
  }

  let fpTags = [];
  let groupTags = [];

  !!tags?.length &&
    tags?.map((tagUri, index) => {
      const tagObj =
        _.find(
          !!tagList && !!tagList?.length && tagList[0],
          ({ uri }) => uri === tagUri
        ) ||
        _.find(
          !!tagList &&
            tagList?.length > 1 &&
            !!tagList[1]?.length &&
            tagList[1],
          ({ uri }) => uri === tagUri
        );
      if (!tagObj) {
        return null;
      }
      const label = _.isString(tagObj.label)
        ? tagObj.label
        : tagObj.label[lang];
      const tagUriSplit = tagUri?.split("/");
      const isFPTags = tagUriSplit[1] === "theme" ? true : false;
      if (!!isFPTags) {
        fpTags.push({ tagUri, label, isFPTags });
      } else groupTags.push({ tagUri, label, isFPTags });
    });

  const toogleTaggingSelectorModal = () => {
    setisTaggingSelectorOpened(() => !isTaggingSelectorOpened);
  };

  const stripAllHtml = (html) => {
    if (!html) return '';
    let tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  const sanitizeWysiwyg = (html) => {
    html = html.replace(/&lt;[^&]*&gt;/g, '');
    return html;
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text/plain');
    const modifiedText = stripAllHtml(pastedText);
    document.execCommand('insertText', false, modifiedText);
  };

  return (
    <>
    <Formik
      enableReinitialize
      initialValues={{
        uuid: getValue("uuid", pid),
        isPublic: isPublic,
        language: getValue(
          "language",
          !!radar ? radar?.["phen-data"]?.language : getLanguage()
        ),
        group: getValue("group", gid),
        title: getValue("title", contentData?.title || ""),
        shortTitle: getValue("shortTitle", contentData?.short_title || ""),
        lead: getValue("lead", contentData?.summary || ""),
        phenomenonType: getValue("phenomenonType", contentData?.type),
        video: getValue("videoUrl", contentData?.media?.video || ""),
        stazonChart: getValue("statzonChart", contentData?.media?.statzonChart || ""),
        image: null,
        imageUrl: getValue("imageUrl", contentData?.media?.image || ""),
        imageFile: null,
        videoText: getValue("mediaText", contentData?.media?.text || ""),
        body: getValue("body", contentData?.body || ""),
        relatedPhenomena: getValue(
          "relatedPhenomena",
          contentData?.["related-phenomena-data"] || []
        ),
        newsFeeds: getValue("newsFeeds", contentData?.newsFeeds || []),
        newsFeedInput: "",
        timing: getValue("timing", contentData?.["time_range"]),
        links: getValue("links", contentData?.links || []),
        tags: getValue("tags", tags || []),
        relatedScenarios: relatedScenariosState,
        majorUpdate: "",
      }}
      validate={(values) => {
        const errors = {};

        if (!values.language) {
          errors.language = requestTranslation("fieldMissing");
        }

        if (!!values?.uuid && values?.group === null) {
          errors.group = requestTranslation("fieldMissing");
        }

        if (!values.title) {
          errors.title = requestTranslation("fieldMissing");
        }

       // Validate RSS and Opoint URLs
        if (!!values?.newsFeedInput?.length && !validateUrl(values.newsFeedInput)) {
          errors.newsFeedInput = requestTranslation("newsFeedError");
        }
        if (values?.links?.length) {
          values.links.map((link) => {
            const linkValue = link?.value || link?.url;
            if (!/^(ftp|http|https):\/\/[^ "]+$/.test(linkValue)) {
              errors.links = requestTranslation("linksError");
            }
          });
        }

        return errors;
      }}
      onSubmit={async (values, { setSubmitting, setErrors, errors }) => {
        try {
          await dispatch({type: ACTIONS.ISLOADING, payload: true})
          const originalNewsFeeds = contentData?.newsFeeds ?? getValue("newsFeeds", []);
          const feedKey = feed => feed.url || feed.title;
          const addedNewsFeeds = uniqBy(
            differenceBy(values.newsFeeds, originalNewsFeeds, feedKey),
            feedKey
          );
          const deletedNewsFeeds = differenceBy(
            originalNewsFeeds,
            values.newsFeeds,
            feedKey
          );

          const phenomenonInput = {
            ...values,
          };

          const storedImg =
            !!fileImg && 
            await handleImageUploadIfNeeded(fileImg, gid);
            // (await votingApi.storeImgToDb(gid, fileImg));
          const date = new Date();

          let day = date.getDate();
          let month = date.getMonth() + 1;
          let year = date.getFullYear();
          // This arrangement can be altered based on how we want the date's format to appear.
          let currentDate = `${day}.${month}.${year}`;
          const isMajorUpdateTemp = majorUpdate?.isMajorUpdate;

        try {
          // First, delete the news feeds
          await Promise.all(map(
            deletedNewsFeeds,
            newsFeed => newsFeedApi.removeNewsFeed(gid, newsFeed.id, pid)
          ));
        } catch (error) {
          throw new Error(`Failed to remove news feeds: ${error.response?.data?.message || error?.message}`);
        }

        try {
          const res =  await Promise.all([
            Promise.all(map(
              addedNewsFeeds,
              newsFeed => newsFeedApi.addNewsFeed(gid, newsFeed?.url || newsFeed?.title, pid)
            )),
            await upsertDocument({
              group: gid,
              isPublic: isPublic,
              latestupdate_editorName: !!isMajorUpdateTemp ? Number(gid) !== 0 ? String(getUsername()) : "Futures Platform" : phenomenonData?.latestupdate_editorName || '',
              latestUpdate_v2: !!isMajorUpdateTemp ? new Date().getTime() : (phenomenonData?.latestUpdate_v2 || null),
              type: "phenomenon",
              id: pid,
              language: phenomenonInput?.language || "en",
              content: {
                title: phenomenonInput?.title,
                short_title: phenomenonInput?.shortTitle,
                summary: phenomenonInput?.lead,
                body: phenomenonInput?.body,
                type: phenomenonInput?.phenomenonType,
                media: {
                  video: phenomenonInput?.video,
                  image:
                    !!storedImg
                      ? `${storedImg}`
                      : phenomenonInput?.imageUrl || "",
                  text: phenomenonInput?.videoText,
                  statzonChart: phenomenonInput?.stazonChart,
                },
                related_phenomena: phenomenonInput?.relatedPhenomena?.map(
                  (r) => r?.id
                ),
                related_scenarios: phenomenonInput?.relatedScenarios?.map(
                  (r) => r?.id
                ),
                feed_tags: [],
                time_range: phenomenonInput?.timing,
                links: phenomenonInput?.links,
                historyLogs: [
                  ...historyDataState,
                  {
                    ...majorUpdate,
                    editorName:
                      Number(gid) !== 0 ? getUsername() : "Futures Platform",
                    isCreator: false,
                    isShown: true,
                    date: currentDate,
                    id: new Date().getTime(),
                    timestamp: new Date().getTime(),
                  },
                ],
              },
              archived: false,
            }),
          ]);

          await mutateContentCard();
          setSubmitting(false);
           onCancel();

            await setTimeout(() => {
          dispatch({ type: ACTIONS.ISLOADING, payload: false });
        }, 2000);
        } catch (error) {
          const errorMessage = error?.response?.data?.message || error?.response?.data?.error || error?.message;
          throw new Error(`Failed to update phenomenon: ${errorMessage}`);
        }

        
        } catch (error) {
          console.error("API Error:", error);
          
          let errorMessage = 'An unknown error occurred';
          
          // Handle Axios error responses with status codes
          if (error.response) {
            const { status, data, statusText } = error.response;
            
            // Get specific error message based on status code
            switch (status) {
              case 413:
                errorMessage = "413 Payload Too Large: The content you're trying to save exceeds the server's size limit. Try reducing the size of your content (especially images).";
                break;
              case 401:
                errorMessage = "401 Unauthorized: Please log in again to continue.";
                break;
              case 403:
                errorMessage = "403 Forbidden: You don't have permission to perform this action.";
                break;
              case 404:
                errorMessage = "404 Not Found: The requested resource was not found.";
                break;
              case 422:
                errorMessage = "422 Unprocessable Entity: The server couldn't process your request due to validation errors.";
                break;
              case 500:
                errorMessage = "500 Internal Server Error: Something went wrong on the server. Please try again later.";
                break;
              default:
                // Use server-provided message if available, or create a generic one
                errorMessage = data?.message || `Error ${status}: ${statusText}`;
            }
            
            // Handle field-specific validation errors
            if (data && data.errors && typeof data.errors === 'object') {
              setErrors(data.errors);
              return; // Exit early as field errors are set
            }
          } 
          // Handle network errors (no response from server)
          else if (error.request) {
            errorMessage = "Network Error: Could not connect to the server. Please check your internet connection.";
          } 
          // Handle other types of errors
          else if (error?.message) {
            errorMessage = error?.message;
          }
          else {
            errorMessage = error || error?.message || JSON.stringify(error);
          }
          // Set Formik errors for form validation
          setErrors({ message: errorMessage });
          
          // Create error object for ErrorModal component
          const errorObj = { message: errorMessage };
          setErrorsList([errorObj]);
          
          // Ensure loading state is removed
          dispatch({ type: ACTIONS.ISLOADING, payload: false });
        }

      
      }}
    >
      {({
        values,
        setFieldValue,
        setFieldTouched,
        touched,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        isValid,
      }) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          setGroupId(values.group);
        }, [values.group]);

        const addNewsFeed = () => {
          if (!errors.newsFeedInput) {
            setFieldValue("newsFeeds", [
              ...values.newsFeeds,
              { title: values.newsFeedInput, url: values.newsFeedInput },
            ]);
            setFieldValue("newsFeedInput", "");
          }
        };

        const setPhenomenonType = ({
          target: {
            previousSibling: { value },
          },
        }) => {
          setFieldValue("phenomenonType", value);
        };

        const toggleRelatedPhenomenon = (phenomenon) => {
          const exists = values.relatedPhenomena.find(
            (relatedPhenomenon) => phenomenon.id === relatedPhenomenon.id
          );
          setFieldValue(
            "relatedPhenomena",
            exists
              ? values.relatedPhenomena.filter(
                  (relatedPhenomenon) => phenomenon.id !== relatedPhenomenon.id
                )
              : values.relatedPhenomena.concat([phenomenon])
          );
        };
        const toggleRelatedScenarios = (phenomenon) => {
          const exists = values.relatedScenarios.find(
            (relatedScenarios) => phenomenon.id === relatedScenarios.id
          );
          setFieldValue(
            "relatedScenarios",
            exists
              ? values.relatedScenarios.filter(
                  (relatedScenarios) => phenomenon.id !== relatedScenarios.id
                )
              : values.relatedScenarios.concat([phenomenon])
          );
          setrelatedScenariosState(() =>
            exists
              ? values.relatedScenarios.filter(
                  (relatedScenarios) => phenomenon.id !== relatedScenarios.id
                )
              : values.relatedScenarios.concat([phenomenon])
          );
        };
        const setRelatedPhenomenaSort = ({ newIndex, oldIndex }) => {
          const ordered = values.relatedPhenomena.slice();
          ordered.splice(newIndex, 0, ordered.splice(oldIndex, 1)[0]);
          setFieldValue("relatedPhenomena", ordered);
        };

        const setRelatedScenariosSort = ({ newIndex, oldIndex }) => {
          const ordered = values.relatedScenarios.slice();
          ordered.splice(newIndex, 0, ordered.splice(oldIndex, 1)[0]);
          setFieldValue("relatedScenarios", ordered);
        };

        const removeNewsFeed = (newsFeed) => {
          setFieldValue(
            "newsFeeds",
            values.newsFeeds.filter(({ title }) => title !== newsFeed.title)
          );
        };

        const handleImageSelect = (e, file) => {
          const fileName = file || e.target.files[0];
          const reader = new FileReader();

          reader.onload = () => {
            let img = new Image();
            img.src = URL.createObjectURL(fileName);

            img.onload = () => {
              setFieldValue("image", reader.result);
              setFieldValue("imageFile", fileName);
            };
          };

          reader.readAsDataURL(fileName);
          setfileImg(fileName);
        };

        const group = groups.find((group) => group?.id === Number(gid));

        if (!!values?.uuid && !group) {
          return (
            <div className="text-center text-danger py-5">
              You do not have the permission to{" "}
              {values.uuid ? "edit this" : "add a"} phenomenon.
            </div>
          );
        }
        const isEmbedRadar =
          !!window &&
          !!window.location &&
          !!window.location.ancestorOrigins?.length
            ? true
            : false;

        return (
          <>
          <div style={{ position: "relative" }}>
           
            <div className="modal-form-sections">
              <div className="modal-form-section modal-form-header">
                <h2>{requestTranslation("createPhenomenaFormTitle")}</h2>
              </div>
             
            
              {!values.uuid && (
                <div className="modal-form-section">
                  <div className="row">
                    {!radar && (
                      <div className="col-6">
                        <div className="form-group">
                          <h3>{requestTranslation("group")}</h3>
                          <Select
                            name="group"
                            className="fp-radar-select fp-radar-select--no-margin w-100"
                            value={values.group}
                            valueKey="id"
                            onBlur={() => setFieldTouched("group")}
                            onChange={(group) => {
                              setFieldValue("group", group ? group.id : null);
                            }}
                            options={groups}
                            searchable={false}
                            clearable={false}
                          />
                          {touched.group && errors.group && (
                            <div className="description text-danger">
                              {errors.group}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="col-6">
                      <div className="form-group">
                        <h3>{requestTranslation("language")}</h3>
                        <Select
                          name="language"
                          className="fp-radar-select fp-radar-select--no-margin w-100"
                          value={values.language}
                          onChange={({ value }) => {
                            setFieldValue("language", value);
                            setFieldValue("relatedPhenomena", []);
                          }}
                          options={getAvailableLanguages()}
                          searchable={false}
                          clearable={false}
                        />
                        {touched.language && errors.language && (
                          <div className="description text-danger">
                            {errors.language}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <p className="mb-0 mt-2">
                    {requestTranslation(
                      "createPhenomenaFormLanguageDescription"
                    )}
                  </p>
                </div>
              )}
              <div className="modal-form-section">
                <h3>{requestTranslation("createPhenomenaFormTypeLabel")}</h3>
                <div className="d-flex flex-wrap">
                  {!contentData?.phenomenonType && (
                    <div className="py-5 text-center">Loading...</div>
                  )}
                  {/* {errorPhenomenonTypes && <div className="py-5 text-center text-danger">{error.message}</div>} */}
                  <div
                    className="custom-phenomenon-types"
                    style={{
                      flexWrap: "wrap",
                      display: "flex",
                      width: "100%",
                      marginBottom: "20px",
                    }}
                  >
                    {!!contentData?.phenomenonType &&
                      !!contentData?.phenomenonType?.length &&
                      contentData?.phenomenonType
                        ?.filter((t) => Boolean(t.groupType))
                        .map(({ id, title, style }) => (
                          <PhenomenonTypeRadiobox
                            key={id}
                            id={id}
                            name="type"
                            label={capitalize(title)}
                            checked={values.phenomenonType === id}
                            style={style}
                            onClick={setPhenomenonType}
                          />
                        ))}
                  </div>
                  <div
                    className="public-phenomenon-types"
                    style={{
                      flexWrap: "wrap",
                      display: "flex",
                      width: "100%",
                    }}
                  >
                    {!!contentData?.phenomenonType &&
                      !!contentData?.phenomenonType?.length &&
                      contentData?.phenomenonType
                        ?.filter((t) => !t.groupType)
                        .map(({ id, alias, style }, i) => (
                          <PhenomenonTypeRadiobox
                            id={id}
                            name="phenomenonType"
                            type={alias}
                            key={id}
                            label={requestTranslation(alias)}
                            checked={values.phenomenonType === id}
                            style={style}
                            onClick={setPhenomenonType}
                            stylesWrapper={{paddingTop : i >=3 ? '0.6rem' : 0}}
                          />
                        ))}
                  </div>
                </div>
              </div>
              <div className="modal-form-section">
                <h3>
                  {requestTranslation("createPhenomenaFormTitleAndLeadLabel")}
                </h3>
                <p>
                  {requestTranslation(
                    "createPhenomenaFormTitleAndLeadDescription"
                  )}
                </p>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <h4>
                        {requestTranslation("createPhenomenaFormTitleLabel")}
                      </h4>
                      <Input
                        type="text"
                        name="title"
                        value={values.title}
                        onChange={handleChange}
                        onPaste={handlePaste}
                        onBlur={(e) => {
                          setFieldValue('title', stripAllHtml(e.target.value));
                          handleBlur(e);
                        }}
                      />
                      {touched.title && errors.title && (
                        <div className="description text-danger">
                          {errors.title}
                        </div>
                      )}
                      <p className={"description"}>
                        {requestTranslation(
                          "createPhenomenaFormTitleDescription"
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <h4>
                        {requestTranslation(
                          "createPhenomenaFormShortTitleLabel"
                        )}
                      </h4>
                      <Input
                        type="text"
                        name="shortTitle"
                        value={values.shortTitle}
                        onChange={handleChange}
                        onPaste={handlePaste}
                        onBlur={(e) => {
                          setFieldValue('shortTitle', stripAllHtml(e.target.value));
                          handleBlur(e);
                        }}
                      />
                      <p className={"description"}>
                        {requestTranslation(
                          "createPhenomenaFormShortTitleDescription"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <h4>{requestTranslation("createPhenomenaFormLeadLabel")}</h4>
                  <ReactQuill
                    className="fp-wysiwyg custom-quill"
                    preserveWhitespace={true}
                    style={{
                      height: "150px",
                      borderBottom: "1px solid #ccc",
                      whiteSpace: "pre",
                      // paddingBottom: '42px'
                    }}
                    modules={quillModules}
                    formats={quillFormats}
                    value={values.lead}
                    onChange={(value) => setFieldValue("lead", value)}
                    onBlur={(range, role, field) => {
                      setTimeout(() => {
                        setFieldValue('lead', sanitizeWysiwyg(field.getHTML()));
                      }, 50);
                    }}
                  />
                </div><script>asd</script>
                <h3>
                  {requestTranslation("createPhenomenaFormMainContentLabel")}
                </h3>
                <div className="form-group">
                  <ReactQuill
                    className="fp-wysiwyg custom-quill"
                    preserveWhitespace={true}
                    style={{
                      height: "250px",
                      borderBottom: "1px solid #ccc",
                      whiteSpace: "pre",
                      // paddingBottom: '42px',
                    }}
                    modules={quillModules}
                    formats={quillFormats}
                    value={values.body}
                    onChange={(value) => setFieldValue("body", value)}
                    onBlur={(range, role, field) => {
                      setTimeout(() => {
                        setFieldValue('body', sanitizeWysiwyg(field.getHTML()));
                      }, 50);
                    }}
                  />
                </div>
              </div>

              <div className="modal-form-section">
                <h3 className="mb-0" style={{ paddingBottom: "21px" }}>
                  {requestTranslation("timing")}
                </h3>
                <div>
                  <div>
                    {requestTranslation("estimatedTimeRange")}
                    <b>
                      {" "}
                      {values?.timing ? values.timing?.min : ""}-
                      {values?.timing ? values?.timing?.max : ""}
                    </b>
                  </div>
                  <PhenomenaTimingEditor
                    updateTiming={(value) => setFieldValue("timing", value)}
                    timing={values?.timing}
                  />
                </div>
              </div>
              <div className="modal-form-section">
                <Dropdown
                  className="dropdown-toggle d-flex align-items-center justify-content-between"
                  type="button"
                  // data-toggle="collapse"
                  data-target="#collapsemedia"
                  aria-expanded={
                    mainVideoAndImage === 'expand_more' ? 'true' : 'false'
                  }
                  style={{ cursor: "pointer" }}
                  onClick={handleChangeIconMainVideoImagesSection}
                >
                  <h3 className="mb-0">
                    {requestTranslation("media")}
                    <DropdownValue>
                      {values.video || values.image || values.imageUrl
                        ? " : " + requestTranslation("hasYESTagged")
                        : " : " + requestTranslation("hasNOTagged")}
                    </DropdownValue>
                  </h3>
                  <div>
                    <i className="material-icons">{mainVideoAndImage}</i>
                  </div>
                </Dropdown>
                <div id="collapsemedia" className={`${
                          mainVideoAndImage === 'expand_more'
                            ? ' collapse show mt-4'
                            : ' collapse mt-4'
                        }`}>
                  <h4>{requestTranslation("video")}</h4>
                  <Input
                    name="video"
                    type="text"
                    value={values.video}
                    onChange={handleChange}
                    onPaste={handlePaste}
                    onBlur={(e) => {
                      setFieldValue('video', stripAllHtml(e.target.value));
                      handleBlur(e);
                    }}
                  />
                  <p className={"description"}>
                    {requestTranslation("videoFormatsText")}
                  </p>
                  <p className={"description"}>
                    {requestTranslation("youtubeFormat")}
                    <br />
                    {requestTranslation("vimeoFormat")}
                  </p>
                  <div className="form-group">
                    <h4>{requestTranslation("image")}</h4>
                    <SelectImageContainer>
                      {!values.imageUrl &&
                        !values.image &&
                        requestTranslation("noImageSelected")}
                      {(values?.imageUrl || values?.image) && (
                        <div
                          className="position-relative w-100"
                          style={{ backgroundColor: "rgba(0,0,0, 0.1)" }}
                        >
                          <img
                            alt=""
                            className="img-fluid"
                            src={
                              !isEmbedRadar
                                ? values?.image || values?.imageUrl
                                : `${
                                    values?.image || values?.imageUrl
                                  }?access_token=${getSessionToken()}`
                            }
                          />
                          <RadarImageCloseContainer
                            onClick={() => {
                              setFieldValue("image", null);
                              setFieldValue("imageFile", null);
                              setFieldValue("imageUrl", null);
                            }}
                          >
                            <RadarImageClose className="material-icons">
                              close
                            </RadarImageClose>
                          </RadarImageCloseContainer>
                        </div>
                      )}
                      <SelectImageInputContainer>
                        <SelectImageInput
                          type="file"
                          accept="image/*"
                          onChange={handleImageSelect}
                          placeholder={requestTranslation("select")}
                        />
                        <SelectImageButton className="btn btn-sm btn-outline-secondary">
                          {requestTranslation("select")}
                        </SelectImageButton>
                      </SelectImageInputContainer>
                    </SelectImageContainer>
                    <p className={"description"}>
                      {requestTranslation("imageUploadDescription")}
                    </p>
                  </div>

                    
                  {isFPEditorRole && (
                    <>
                      <h4>{requestTranslation("StatzonChart") ?? "Statzon Chart"}</h4>
                      <Input
                        name="stazonChart"
                        type="text"
                        value={values.stazonChart}
                        onChange={handleChange}
                        onPaste={handlePaste}
                        onBlur={(e) => {
                          setFieldValue('stazonChart', stripAllHtml(e.target.value));
                          handleBlur(e);
                        }}
                      />
                    </>
                  )}
                 
                  {/* <p className={"description"}>
                    {requestTranslation("videoFormatsTextStatzonChart")}
                  </p>
                  <p className={"description"}>
                    {requestTranslation("youtubeFormatStatzonChart")}
                    <br />
                    {requestTranslation("vimeoFormatStatzonChart")}
                  </p> */}



                  <div className="form-group">
                    <h4>
                      {requestTranslation("createPhenomenaFormVideoLabel")}
                    </h4>
                    <Input
                      type={"text"}
                      name="videoText"
                      value={values.videoText}
                      onChange={handleChange}
                      onPaste={handlePaste}
                      onBlur={(e) => {
                        setFieldValue('videoText', stripAllHtml(e.target.value));
                        handleBlur(e);
                      }}
                    />
                    <p className={"description"}>
                      {requestTranslation(
                        "createPhenomenaFormVideoDescription"
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="modal-form-section">
                <Dropdown
                  className="dropdown-toggle d-flex align-items-center justify-content-between"
                  type="button"
                  // data-toggle="collapse"
                  data-target="#collapselinks"
                  aria-expanded={
                    links2WebpagesSection === 'expand_more' ? 'true' : 'false'
                  }
                  style={{ cursor: "pointer" }}
                  onClick={handleChangeIconLinks2WebpagesSection}
                >
                  <h3 className="mb-0">
                    {requestTranslation("phenomenaLinks")}
                    <DropdownValue>
                      {!!values?.links?.length
                        ? " : " + requestTranslation("hasYESTagged")
                        : " : " + requestTranslation("hasNOTagged")}
                    </DropdownValue>
                  </h3>
                  <div>
                    <i className="material-icons">{links2WebpagesSection}</i>
                  </div>
                </Dropdown>
                <div id="collapselinks" className={`${
                          links2WebpagesSection === 'expand_more'
                            ? ' collapse show mt-4'
                            : ' collapse mt-4'
                        }`}>
                  <PhenomenaLinks
                    onChange={(value) => {
                      setFieldValue("links", value);
                      // await dispatch({
                      //   type: ACTIONS.CONTENTCARDDATA,
                      //   payload: {
                      //     ...contentData,
                      //     links: value
                      //   }
                      // })
                    }}
                    values={values.links}
                  />
                </div>
              </div>
              <div className="modal-form-section">
                <Dropdown
                  className="dropdown-toggle d-flex align-items-center justify-content-between"
                  type="button"
                  // data-toggle="collapse"
                  data-target="#collapsenews"
                  aria-expanded={
                    iconNewsFeedSection === 'expand_more' ? 'true' : 'false'
                  }
                  style={{ cursor: "pointer" }}
                  onClick={handleChangeIconNewsFeedSection}
                >
                  <h3 className="mb-0">
                    {requestTranslation("newsFeed")}
                    <DropdownValue>
                      {values?.newsFeedInput ||
                      (Array.isArray(values?.newsFeeds) &&
                        values?.newsFeeds?.length > 0)
                        ? " : " + requestTranslation("hasYESTagged")
                        : " : " + requestTranslation("hasNOTagged")}
                    </DropdownValue>
                  </h3>
                  <div>
                    <i className="material-icons">{iconNewsFeedSection}</i>
                  </div>
                </Dropdown>
                <div id="collapsenews" className={`${
                          iconNewsFeedSection === 'expand_more'
                            ? ' collapse show mt-4'
                            : ' collapse mt-4'
                        }`}>
                  <p>{requestTranslation("feedDescription")}</p>
                  <h4 className={"mb-2"}>{requestTranslation("feedUrl")}</h4>
                  <div className="form-row align-items-center">
                    <div className="col-6 my-1">
                      <Input
                        className="mb-0"
                        name="newsFeedInput"
                        type={"text"}
                        value={values.newsFeedInput}
                        onChange={handleChange}
                        onPaste={handlePaste}
                        onBlur={(e) => {
                          setFieldValue('newsFeedInput', stripAllHtml(e.target.value));
                          handleBlur(e);
                        }}
                      />
                    </div>
                    <div className={"col-auto my-1"}>
                      <button
                        onClick={addNewsFeed}
                        disabled={!!errors.newsFeedInput}
                        className="btn btn-outline-secondary"
                      >
                        {requestTranslation("addFeed").toUpperCase()}
                      </button>
                    </div>
                    {touched.newsFeedInput && errors.newsFeedInput && (
                      <div className={"col-6"}>
                        <div className="invalid-feedback d-flex">
                          {errors.newsFeedInput}
                        </div>
                      </div>
                    )}
                  </div>
                  <h4 className={"mb-2"}>{requestTranslation("addedFeeds")}</h4>
                  {values?.newsFeeds?.length > 0 &&
                    map(values?.newsFeeds, (newsFeed, index) => (
                      <div key={newsFeed.title + index} className="d-flex mb-1">
                        <DeleteRowButton
                          onClick={() => removeNewsFeed(newsFeed)}
                        >
                          <CloseIcon className="material-icons">
                            close
                          </CloseIcon>
                        </DeleteRowButton>
                        <p className="mb-0">{newsFeed.title}</p>
                      </div>
                    ))}
                  {values?.newsFeeds?.length === 0 && (
                    <p className="description">
                      {requestTranslation("noFeeds")}
                    </p>
                  )}
                </div>
              </div>

              <div className="modal-form-section">
                <Dropdown
                  className="dropdown-toggle d-flex align-items-center justify-content-between"
                  type="button"
                  // data-toggle="collapse"
                  data-target="#collapserelated"
                  aria-expanded={
                    iconRelatedNodeSection === 'expand_more' ? 'true' : 'false'
                  }
                  style={{ cursor: "pointer" }}
                  onClick={handleChangeIconRelatedNodesSection}
                >
                  <h3 className="mb-0">
                    {requestTranslation("relatedPhenomena")}
                    <DropdownValue>
                      {values?.relatedPhenomena?.length
                        ? " : " + requestTranslation("hasYESTagged")
                        : " : " + requestTranslation("hasNOTagged")}
                    </DropdownValue>
                  </h3>
                  <div>
                    <i className="material-icons">{iconRelatedNodeSection}</i>
                  </div>
                </Dropdown>
                <div id="collapserelated" className={`${
                          iconRelatedNodeSection === 'expand_more'
                            ? ' collapse show mt-4'
                            : ' collapse mt-4'
                        }`}>
                  <div style={{ overflow: "hidden" }} className="row">
                    <div className="col-12 col-md-4">
                      {values?.relatedPhenomena?.length > 0 && (
                        <SortableRelatedPhenomenaList
                          relatedPhenomena={values.relatedPhenomena}
                          onSelect={toggleRelatedPhenomenon}
                          onSortEnd={setRelatedPhenomenaSort}
                        />
                      )}
                      <p className={"description"}>
                        {requestTranslation("relatedPhenomenaText")}
                      </p>
                    </div>
                    <div className="col-12 col-md-8" style={{ padding: 0 }}>
                      <RelatedPhenomena>
                        <PhenomenaSelector
                          small
                          gid={gid}
                          phenomena={
                            values.uuid
                              ? [
                                  {
                                    ...phenomenon,
                                    id: pid,
                                  },
                                ]
                              : []
                          }
                          listView={!radar}
                          selectedPhenomena={values.relatedPhenomena}
                          language={values.language}
                          radarId={radar && radar.id}
                          onSelect={toggleRelatedPhenomenon}
                          filter={false}
                          group={values?.group || gid}
                          // createOrEditMode={createOrEditMode}
                        />
                      </RelatedPhenomena>
                    </div>
                  </div>
                </div>
              </div>

              {true && (
                <div
                  className="modal-form-section"
                  style={{ zIndex: 1, position: "relative" }}
                >
                  {/* <div
                      style={{
                        zIndex: 999999,
                        position: 'absolute',
                        top: '36px',
                        right: '10%',
                        width: '370px',
                      }}>
                      <ToggleSwitcher
                        labelText={
                          'Show related scenarios on the scenario card'
                        }
                        isDeactivated={isRelatedScenariosDeactivated}
                        type="relatedScenariosToogle"
                      />
                    </div> */}

                  <Dropdown
                    className="dropdown-toggle d-flex align-items-center justify-content-between"
                    type="button"
                    // data-toggle="collapse"
                    data-target="#collapserelated_scenarios"
                    aria-expanded={
                      iconRelatedNodeSSSection === 'expand_more' ? 'true' : 'false'
                    }
                    style={{ cursor: "pointer" }}
                    onClick={handleChangeIconRelatedSSNodesSection}
                  >
                    <div
                      style={{
                        display: "flex",
                        marginBottom: "14.4px",
                        alignItems: "center",
                      }}
                    >
                      <h3
                        className="mb-0"
                        style={{
                          fontFamily: "L10",
                          fontStyle: "normal",
                          fontWeight: 700,
                          fontSize: "20px",
                          lineHeight: "31px",
                          letterSpacing: "0.0928571px",
                          margin: 0,
                        }}
                      >
                        {requestTranslation("relatedScenario")}
                        <DropdownValue>
                          {values?.relatedScenarios?.length
                            ? " : " + requestTranslation("hasYESTagged")
                            : " : " + requestTranslation("hasNOTagged")}
                        </DropdownValue>
                      </h3>

                      <InformationIcon
                        style={{
                          marginTop: 0,
                          marginBottom: 0,
                        }}
                        background={false}
                        onMouseEnter={onHoverStep1Icon}
                        onMouseLeave={onLeaveStep1Icon}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setrelatedScenariosEditorInfo(true);
                        }}
                      />
                      <InformationModal2
                        InfoModalUL={`Here you can link scenarios from Futures Platform database which are related to this scenario. The other scenarios in this scenario set will automatically be added so you don’t need to add them.`}
                        // InfoModalDescription2="Instruct the division of work: who writes which scenario."
                        // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                        // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                        // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                        // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                        // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                        // how many events are need in each scenario."
                        // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                        // style should be followed?"
                        InfoModalHeader={
                          "Related scenarios used in this scenario"
                        }
                        // InfoModalNote={
                        //   'A short and distinctive name to your scenario project'
                        // }
                        InfoModalOpen={relatedScenariosEditorInfo}
                        InfoModalClose={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setrelatedScenariosEditorInfo(false);
                        }}
                        // LearnMoreBtn={'How to write the scenario texts?'}
                        // GuideBtn={requestTranslation('GuideVotingBtn')}
                        // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                        // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                      />
                    </div>
                    <div>
                      <i className="material-icons">
                        {iconRelatedNodeSSSection}
                      </i>
                    </div>
                  </Dropdown>
                  <div id="collapserelated_scenarios" className={`${
                          iconRelatedNodeSSSection === 'expand_more'
                            ? ' collapse show mt-4'
                            : ' collapse mt-4'
                        }`}>
                    <div style={{ overflow: "hidden" }} className="row">
                      <div className="col-12 col-md-4">
                        {values?.relatedScenarios?.length > 0 && (
                          <SortableRelatedPhenomenaList
                            relatedPhenomena={values.relatedScenarios}
                            onSelect={toggleRelatedScenarios}
                            onSortEnd={setRelatedScenariosSort}
                          />
                        )}
                        <p className={"description"}>Related scenarios</p>
                      </div>
                      <div className="col-12 col-md-8" style={{ padding: 0 }}>
                        <RelatedPhenomena>
                          <ScenariosSelector
                            small
                            gid={gid}
                            phenomena={[]}
                            listView={false}
                            selectedPhenomena={
                              values.relatedScenarios ||
                              relatedScenariosState ||
                              relatedScenarios ||
                              []
                            }
                            language={values?.language || lang || "en"}
                            radarId={false}
                            onSelect={toggleRelatedScenarios}
                            filter={false}
                            group={values?.group || gid}
                            // createOrEditMode={createOrEditMode}
                          />
                        </RelatedPhenomena>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div style={{
                position: "relative",
              }}>
 {!!tagList?.length && !!isTaggingSelectorOpened && (
              <PhenomenaTagSelector
                gid={gid}
                rid={rid}
                pid={pid}
                phenomenon={contentData}
                tagList={tagList}
                tags={contentData?.tags}
                groupTags={groupTags}
                fpTags={fpTags}
                lang={lang}
                mutateTaglist={mutateTaglist}
                mutateContentCard={mutateContentCard}
              />
            )}
                <div className="modal-form-section">
                  <Dropdown
                    className="dropdown-toggle d-flex align-items-center justify-content-between"
                    type="button"
                    // data-toggle="collapse"
                    data-target="#collapsetags"
                    aria-expanded={
                      iconTaggingSection === 'expand_more' ? 'true' : 'false'
                    }
                    onClick={handleChangeIconTagSection}
                    style={{ cursor: "pointer", display: "flex" }}
                  >
                    <h3
                      className="mb-0"
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {requestTranslation("TagsPhenomenon") || "Tags"}
                      <DropdownValue>
                        <>
                          {!!contentData?.tags?.length && (
                            <div>
                              {" "}
                              {" : "} {requestTranslation("hasYESTagged")}{" "}
                            </div>
                          )}
                          {!contentData?.tags?.length && (
                            <div>
                              {" "}
                              {" : "} {requestTranslation("hasNOTagged")}{" "}
                            </div>
                          )}
                        </>
                        {/* {
                                  (!!editModal && editModal?.type === 'CREATE') 
                                    ? requestTranslation('hasNoTagged') 
                                    : ((!!phenomenonIncludesTagData?.tags  ? !!phenomenonIncludesTagData?.tags?.length :  !!storedPhenSelector?.tags?.length ) ? requestTranslation('hasTagged') : requestTranslation('hasNoTagged'))
                                } */}
                      </DropdownValue>
                    </h3>
                    <div>
                      <i className="material-icons">{iconTaggingSection}</i>
                    </div>
                  </Dropdown>
                  <div id="collapsetags" className={`${
                            iconTaggingSection === 'expand_more'
                              ? ' collapse show mt-4'
                              : ' collapse mt-4'
                          }`}>
                    <div style={{ overflow: "hidden" }} className="row">
                      <div className="col-12 ">
                        <PhenomenaTagList
                          // phenomena={phenomenonIncludesTagData}
                          // language={language.value || language}
                          // tagList={tagList}
                          // editModal={'editModal2345'}
                          phenomena={[]}
                          language={lang}
                          tagList={tagList}
                          tags={values?.tags}
                          groupTags={groupTags}
                          fpTags={fpTags}
                          editModal={"editModal2345"}
                        />
                        <div
                          style={{
                            display: "flex",
                            marginTop: "32px",
                            marginLeft: "-18px",
                          }}
                        >
                          <Icon
                            // ref={itemsRef.current[indexForTagging]}
                            // path={phenomenonToTag && phenomenonToTag.id === (!!phenomenonIncludesTagData ? phenomenonIncludesTagData?.id : (storedPhenSelector?.id || null) ) ? mdiTagPlus : mdiTagPlusOutline}
                            path={
                              !isTaggingSelectorOpened
                                ? mdiTagPlusOutline
                                : mdiTagPlus
                            }
                            // className={`fp-text-icon ${canTag ? 'hoverable' : ''}`}
                            className={`fp-text-icon hoverable`}
                            size={1}
                            // color={!canTag ? 'gray' : '#006998'}
                            color={"#006998"}
                            style={{ position: "relative", top: "1px" }}
                            onClick={toogleTaggingSelectorModal}
                          />

                          <p
                            className={"description"}
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                              color: "#006998",
                              textTransform: "uppercase",
                            }}
                          >
                            {requestTranslation("AddAndRemoveTags")}
                            {/* {!IsCreateNewContentCard ? requestTranslation('AddAndRemoveTags') : requestTranslation('TagsAddedAfterContentcardCreated')} */}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Modal
                              isOpen={openPublicPhenomenonModal}
                              contentLabel="archive-sanity-check"
                              onRequestClose={() => setOpenPublicPhenomenonModal(false)}
                              style={paddingModalStyles}
                              className={'paddedModal'}
                              ariaHideApp={false}
                            >
                              <div className={'confirmation-modal-content'}>
                                <h3 className={'confirmation-modal-title'}>
                                  {!isPublic ? requestTranslation('publicPhenomenonConfirmation') : requestTranslation('unpublicPhenomenonConfirmation')}
                                </h3>
                                <p> {isPublic ? requestTranslation('publicPhenomenonConfirmationDescription') : requestTranslation('unpublicPhenomenonConfirmationDescription')}</p>
                                <p> {!isPublic ? requestTranslation('publicPhenomenonConfirmationDescription2') : requestTranslation('unpublicPhenomenonConfirmationDescription2')}</p>
                                <div className={'confirmation-modal-actions'} style={{ display: 'flex', alignItems: 'center', gap: '16px', justifyContent: 'center'}}>
                                  <button
                                    className="btn btn-lg btn-plain-gray"
                                    onClick={() => setOpenPublicPhenomenonModal(false)}
                                  >
                                    {requestTranslation('cancel')}
                                  </button>
                                  <button
                                    className="btn btn-lg btn-primary"
                                    onClick={() => {
                                      setIsPublicPhenomenon(() => !isPublic);

                                      setOpenPublicPhenomenonModal(false)
                                    }}
                                  >
                                    {!isPublic ? requestTranslation('puplishContentConfirmationBtn') : requestTranslation('unpublishContentConfirmationBtn')}
                                  </button>
                                </div>
                              </div>
                            </Modal>
                {
               (!!thisGroupData?.publicPhenomena || Number(gid) === 0) && (
                <div className="modal-form-section">
                <Dropdown
                  className="dropdown-toggle d-flex align-items-center justify-content-between"
                  type="button"
                  // data-toggle="collapse"
                  data-target="#collapse-public-phenomenon"
                  aria-expanded={
                    iconPublicPhenomenonSection === 'expand_more'
                      ? 'true'
                      : 'false'
                  }
                  style={{ cursor: "pointer" }}
                  // onClick={handleChangeIconPublicPhenomenonSection}
                >
                  <h3 className="mb-0">
                    {requestTranslation("publicPhenomenon")}
                  </h3>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* <p
                      style={{
                        margin: 0,
                        marginRight: "24px",
                        fontWeight: "100",
                      }}
                    >
                      {requestTranslation("publicPhenomenon")}
                    </p> */}
                    <div style={{ marginRight: "24px" }}>
                      <ToggleSwitcher
                        checked={isPublic}
                        toggleHandler={() => {
                          // setIsPublicPhenomenon(() => !isPublic);
                          setOpenPublicPhenomenonModal(true);
                          // e.preventDefault();
                          // e.stopPropagation();
                          
                        }}
                      />
                    </div>
                    {/* <i className="material-icons">
                      {iconPublicPhenomenonSection}
                    </i> */}
                  </div>
                </Dropdown>
               <p className="description" style={{
                                  fontSize: '14px',
                                  fontWeight: '400',
                                  margin: 0,
                                  marginTop: '16px',
                                  // marginLeft: '16px',
                                }}>
                                  {requestTranslation("publicPhenomenonDescription")}
                                </p>
              </div>
              )
             }

             { (isFPEditorRole && contentData?.['phen-data']?.update_recomendation) ? (
                  <div className="modal-form-section" style={{
                  paddingBottom: '1rem',
                }}>
                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                       <div style={{
                         display: 'flex',
                         alignItems: 'center',
                         gap: '8px',
                         justifyContent: 'center'}}>
                         <h3 style={{
                           // fontSize: '20px',
                           margin: 0,
                           fontWeight: '700',
                           marginBottom: 0,
                         }}>
                           {
                           requestTranslation("update_recomendation")
                         }
                         </h3>
                         {contentData?.['phen-data']?.update_recomendation?.date && 
                           (() => {
                             const date = new Date(contentData['phen-data']?.update_recomendation.date);
                             const time = date.toLocaleTimeString('en-GB', { 
                               hour: '2-digit', 
                               minute: '2-digit', 
                               second: '2-digit' 
                             });
                             const day = date.getDate().toString().padStart(2, '0');
                             const month = (date.getMonth() + 1).toString().padStart(2, '0');
                             const year = date.getFullYear();
                             return `${day}.${month}.${year}`;
                           })()
                         }
                       </div>
                       <div 
                       className="card-header-update-recommendation-toggle"
                       onClick={() => setisExpandedUpdateRecommended(!isExpandedUpdateRecommended)}
                       style={{
                         display: 'flex',
                         alignItems: 'center',
                         justifyContent: 'center',
                         gap: '8px',
                         cursor: 'pointer'
                       
                       }}>
                         {
                           !isExpandedUpdateRecommended ? requestTranslation("expand_more_UpdateRecommended") : requestTranslation("expand_less_UpdateRecommended")
                         }
                         {
                         !isExpandedUpdateRecommended ? (<div><i class="material-icons">expand_more</i></div>) : (<div><i class="material-icons">expand_less</i></div>)
                       }
                       </div>
                     </div>
                     {
                       isExpandedUpdateRecommended ? (
                         <div 
                           className="edit-form-update-recommendation"
                           style={{
                             padding: '1rem',
                             maxHeight: '600px',
                             overflowY: 'auto',
                             fontSize: '14px',
                             lineHeight: '1.6',
                             paddingTop: '0.65rem',
                           }}>
                           <div 
                             className="markdown-content"
                             style={{
                               /* Auto-format markdown content with clean spacing */
                             }}
                           >
                             <style dangerouslySetInnerHTML={{
                               __html: `
                                 .edit-form-update-recommendation .markdown-content h1 {
                                   font-size: 1.1rem !important;
                                   font-weight: bold !important;
                                   margin: 28px 0 0 0 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content h2 {
                                   font-size: 1.05rem !important;
                                   font-weight: bold !important;
                                   margin: 26px 0 0 0 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content h3 {
                                   font-size: 1rem !important;
                                   font-weight: bold !important;
                                   margin: 24px 0 0 0 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content h4 {
                                   font-size: 0.95rem !important;
                                   font-weight: bold !important;
                                   margin: 22px 0 0 0 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content h5 {
                                   font-size: 0.9rem !important;
                                   font-weight: bold !important;
                                   margin: 20px 0 0 0 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content h6 {
                                   font-size: 0.85rem !important;
                                   font-weight: bold !important;
                                   margin: 18px 0 0 0 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content p {
                                   margin: 4px 0 0 0 !important;
                                   line-height: 1.5 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content ul, 
                                 .edit-form-update-recommendation .markdown-content ol {
                                   margin: 12px 0 0 0 !important;
                                   padding-left: 18px !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content li {
                                   margin: 6px 0 0 0 !important;
                                   line-height: 1.4 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content li p {
                                   margin: 3px 0 0 0 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content blockquote {
                                   margin: 10px 0 0 0 !important;
                                   padding-left: 12px !important;
                                   border-left: 3px solid #007bff !important;
                                   font-style: italic !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content pre {
                                   margin: 10px 0 0 0 !important;
                                   padding: 8px !important;
                                   background-color: #f1f3f4 !important;
                                   border-radius: 4px !important;
                                   overflow: auto !important;
                                   font-family: monospace !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content code {
                                   background-color: #f1f3f4 !important;
                                   padding: 1px 3px !important;
                                   border-radius: 2px !important;
                                   font-family: monospace !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content hr {
                                   margin: 20px 0 0 0 !important;
                                   border: none !important;
                                   border-top: 1px solid #dee2e6 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content a {
                                   text-decoration: underline !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content strong {
                                   font-weight: bold !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content em {
                                   font-style: italic !important;
                                 }
                                 
                                 /* Override for proper hierarchy: h4 > ol > li spacing */
                                 .edit-form-update-recommendation .markdown-content h4 + ol,
                                 .edit-form-update-recommendation .markdown-content h4 + ul {
                                   margin: 8px 0 0 0 !important;
                                 }
                                 
                                 /* Main numbered sections get medium spacing */
                                 .edit-form-update-recommendation .markdown-content ol > li {
                                   margin: 10px 0 0 0 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content ol > li:first-child {
                                   margin: 6px 0 0 0 !important;
                                 }
                                 
                                 /* Sub-bullets within sections get tight spacing */
                                 .edit-form-update-recommendation .markdown-content ol > li ul,
                                 .edit-form-update-recommendation .markdown-content ol > li ol {
                                   margin: 4px 0 0 0 !important;
                                 }
                                 .edit-form-update-recommendation .markdown-content ol > li ul > li,
                                 .edit-form-update-recommendation .markdown-content ol > li ol > li {
                                   margin: 3px 0 0 0 !important;
                                 }
                               `
                             }} />
                             <Markdown>
                               {contentData?.['phen-data']?.update_recomendation?.reason}
                             </Markdown>
                           </div>
                         </div>
                       ) : null
                     }
                   </div>
                   ) : null
                  }
          
                <div className="modal-form-section">
                  <Dropdown
                    className="dropdown-toggle d-flex align-items-center justify-content-between"
                    type="button"
                    // data-toggle="collapse"
                    data-target="#collapsehistory"
                    aria-expanded={
                      iconHistorySection === 'expand_more' ? 'true' : 'false'
                    }
                    style={{ cursor: "pointer" }}
                    onClick={handleChangeIconHistorySection}
                  >
                    <h3 className="mb-0">
                      {requestTranslation("Historyandchangelog")}
                    </h3>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p
                        style={{
                          margin: 0,
                          marginRight: "24px",
                          fontWeight: "100",
                        }}
                      >
                        {iconHistorySection === "expand_more"
                          ? requestTranslation("ShowHistory")
                          : requestTranslation("HideHistory")}
                      </p>
                      <i className="material-icons">{iconHistorySection}</i>
                    </div>
                  </Dropdown>
                  <Modal
                    isOpen={isEditHistoryModalOpened}
                    onRequestClose={() => onCloseEditingHistory()}
                    style={paddingModalStyles}
                    ariaHideApp={false}
                  >
                    <div className="modal-form-sections">
                      <div
                        className="modal-form-section modal-form-header"
                        style={{ paddingBottom: "1px" }}
                      >
                        <h3>{requestTranslation("editHistory")}</h3>
                      </div>
                      <div
                        id="history-content-card-editor"
                        className="modal-form-section"
                        style={{ paddingTop: 0, cursor: "pointer" }}
                      >
                        <div
                          className="form-group"
                          style={{
                            zIndex: 999999,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <p
                            style={{
                              margin: 0,
                              marginRight: "1.5rem",
                              width: "100px",
                            }}
                          >
                            {historyDataState[currentIndexEditingHistory]
                              ?.isMajorUpdate
                              ? requestTranslation("createdby")
                              : requestTranslation("editOn")}
                          </p>
                          <div>
                            <DatePicker
                              wrapperClassName="datepicker"
                              dateFormat="dd.MM.yyyy"
                              // style={{ width: "60% !important" }}
                              selected={
                                new Date(
                                  `${
                                    historyDataState[
                                      currentIndexEditingHistory
                                    ]?.date?.split(".")[1]
                                  }/${
                                    historyDataState[
                                      currentIndexEditingHistory
                                    ]?.date?.split(".")[0]
                                  }/${
                                    historyDataState[
                                      currentIndexEditingHistory
                                    ]?.date?.split(".")[2]
                                  }`
                                )
                              }
                              onChange={(date) => {
                                const temp = [...historyDataState];
                                const dayTemp = date.getDate();
                                const monthTemp = date.getMonth() + 1;
                                const yearTemp = date.getFullYear();
                                const temp2 =
                                  dayTemp + "." + monthTemp + "." + yearTemp;
                                const temp3 = {
                                  ...temp[currentIndexEditingHistory],
                                };

                                temp3["date"] = temp2;
                                temp3["timestamp"] = new Date(date).getTime();
                                temp[currentIndexEditingHistory] = { ...temp3 };
                                sethistoryDataState(() => [...temp]);
                              }}
                              className=" ml-4"
                              placeholderText={requestTranslation("chooseDate")}
                              minDate={null}
                              maxDate={null}
                            />
                          </div>
                          <p
                            style={{
                              margin: 0,
                              marginRight: "1.5rem",
                              marginLeft: "1.5rem",
                            }}
                          >
                            {requestTranslation("by")}
                          </p>
                          <input
                            style={{
                              width:
                                "calc(100% - (100px + 1.5rem + 125px + 2rem + 15.68px + 1.6px + 1.6px +  1.6px + 1%))",
                              height: "44px",
                              padding: "16px",
                            }}
                            value={
                              Number(gid) !== 0
                                ? historyDataState[currentIndexEditingHistory]
                                    ?.editorName
                                : "Futures Platform"
                            }
                            onChange={userNameEdtingHistoryHandler}
                            onPaste={userNameEdtingHistorySanitize}
                            onBlur={userNameEdtingHistorySanitize}
                          />
                        </div>

                        <div
                          className="form-group"
                          style={{
                            display: "flex",
                            width: "100%",
                          }}
                        >
                          <p
                            style={{
                              marginRight: "1.5rem",
                              width: "100px",
                            }}
                          >
                            {requestTranslation("Description")}
                          </p>
                          <textarea
                            style={{
                              width: "calc(100% - (1.5rem + 100px + 1.6px))",
                              fontSize: "13px",
                              resize: "vertical",
                              overflowY: "auto",
                              height: "100px",
                              margin: 0,
                            }}
                            value={
                              historyDataState[currentIndexEditingHistory]
                                ?.description ?? ""
                            }
                            onInput={descriptionEdtingHistoryHandler}
                            onPaste={descriptionEdtingHistorySanitize}
                            onBlur={descriptionEdtingHistorySanitize}
                            // maxLength="1000" type="text" className={clsx(styles.textAreaStyle,"form-control")} id='comment_textarea' value={valueInput ?? ''} placeholder={'Message *'}
                          />
                        </div>
                      </div>
                    </div>

                    <ButtonsContainer
                      className={"modal-form-section modal-form-actions"}
                    >
                      <button
                        className="btn btn-lg btn-plain-gray"
                        onClick={() => {
                          // setPhenomenonToTag(false)
                          onCloseEditingHistory();
                        }}
                      >
                        {requestTranslation("cancel")}
                      </button>
                      <button
                        className="btn btn-lg btn-primary"
                        onClick={() => {
                          // setPhenomenonToTag(false)
                          // dispatch({
                          //   type: ACTIONS.CURRENTINDEXEDITINGHISTORY,
                          //   payload: -99
                          // })
                          const temp = [...historyDataState];
                          userNameEdtingHistorySanitize({target: {value: temp[currentIndexEditingHistory]['editorName']}})
                          descriptionEdtingHistorySanitize({target: {value: temp[currentIndexEditingHistory]['description']}})
                          setisEditHistoryModalOpened(false);
                        }}
                        // type="submit"
                        disabled={isSubmitting || !isValid}
                      >
                        {requestTranslation("save")}
                      </button>
                    </ButtonsContainer>
                  </Modal>

                  <div id="collapsehistory" className={`${
                        iconHistorySection === 'expand_less'
                          ? ' collapse '
                          : ' collapse show '
                      } mt-4`}>
                    {!!historyDataState?.length &&
                      [...historyDataState]
                        ?.sort((a, b) => b?.timestamp - a?.timestamp)
                        ?.map((h, i) => {
                          return (
                            <HistoryEditor
                              gid={gid}
                              isShowDeleteHistoryModal={isShowDeleteHistoryModal}
                              setisShowDeleteHistoryModal={
                                setisShowDeleteHistoryModal
                              }
                              closeModal={() =>
                                setisEditHistoryModalOpened(false)
                              }
                              openModal={() => setisEditHistoryModalOpened(true)}
                              isEditHistoryModalOpened={isEditHistoryModalOpened}
                              key={h?.id}
                              history={h}
                              index={i}
                              historyDataState={historyDataState}
                              sethistoryDataState={sethistoryDataState}
                            />
                          );
                        })}
                  </div>
                </div>
              </div>

              
  
              <div className="modal-form-section">
                <Dropdown
                  className="dropdown-toggle d-flex align-items-center justify-content-between"
                  type="button"
                  // data-toggle="collapse"
                  data-target="#collapsehistory-major-update"
                  aria-expanded={
                    iconHistoryMajorUpdateSection === 'expand_more'
                      ? 'true'
                      : 'false'
                  }
                  style={{ cursor: "pointer" }}
                  onClick={!!majorUpdate?.isMajorUpdate ? handleChangeIconHistoryMajorSection : null}
                >
                  <h3 className="mb-0">
                    {!!majorUpdate?.isMajorUpdate
                      ? requestTranslation("DescriptionMajorChangeLogs")
                      : ""}
                  </h3>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p
                      style={{
                        margin: 0,
                        marginRight: "24px",
                        fontWeight: "100",
                      }}
                    >
                      {requestTranslation("ShowAsMajorUpdate")}
                    </p>
                    <div style={{ marginRight: "24px" }}>
                      <ToggleSwitcher
                        checked={majorUpdate?.isMajorUpdate}
                        toggleHandler={() => {
                          // e.preventDefault();
                          // e.stopPropagation();
                          if (!!majorUpdate?.isMajorUpdate) {
                            seticonHistoryMajorUpdateSection(
                              () => `expand_less`,
                            )
                          }
                           
                          else {
                            seticonHistoryMajorUpdateSection(
                              () => `expand_more`,
                            )

                          }
                          setmajorUpdate(() => {
                            return {
                              description: !!majorUpdate?.isMajorUpdate
                                ? majorUpdate?.description
                                : "",
                              isMajorUpdate: !majorUpdate?.isMajorUpdate,
                            };
                          });
                        }}
                      />
                    </div>
                    <i className="material-icons">
                      {iconHistoryMajorUpdateSection}
                    </i>
                  </div>
                </Dropdown>
                <div
                  id="collapsehistory-major-update"
                  className={`collapse mt-4 ${
                    iconHistoryMajorUpdateSection === 'expand_more'
                      ? ' collapse show '
                      : ' collapse '
                  }`}
                >
                  {!!majorUpdate?.isMajorUpdate && (
                    <textarea
                      disabled={!majorUpdate?.isMajorUpdate}
                      onInput={(e) => {
                        setmajorUpdate(() => {
                          const temp = e.target.value;
                          return {
                            description: temp,
                            isMajorUpdate: majorUpdate?.isMajorUpdate,
                          };
                        });
                      }}
                      value={majorUpdate?.description}
                      style={{
                        minHeight: "100px",
                      }}
                      rows={4}
                      placeholder={requestTranslation("editingTextHistory")}
                    />
                  )}
                </div>
              </div>
            </div>

            <ButtonsContainer
              className={"modal-form-section modal-form-actions"}
            >
              {!radar && values.uuid && (
                <Fragment>
                  <button
                    className="btn btn-lg btn-plain-red"
                    onClick={() => setDeletingModalOpen(!deletingModalOpen)}
                    style={{
                      marginRight: "auto",
                      paddingLeft: 0,
                    }}
                  >
                    {requestTranslation("delete")}
                  </button>
                  <Modal
                    isOpen={deletingModalOpen}
                    contentLabel="archive-sanity-check"
                    style={paddingModalStyles}
                    className={"paddedModal"}
                    ariaHideApp={false}
                  >
                    <div className={"confirmation-modal-content"}>
                      <h3 className={"confirmation-modal-title"}>
                        {requestTranslation("archiveDoubleCheck")}
                      </h3>
                      <div className={"confirmation-modal-actions"}>
                        <button
                          className="btn btn-lg btn-plain-gray"
                          onClick={() => setDeletingModalOpen(false)}
                        >
                          {requestTranslation("cancel")}
                        </button>
                        <button
                          className="btn btn-lg btn-primary"
                          // onClick={onDelete}
                        >
                          {requestTranslation("delete")}
                        </button>
                      </div>
                    </div>
                  </Modal>
                </Fragment>
              )}
              <button
                className="btn btn-lg btn-plain-gray"
                onClick={() => {
                  // setPhenomenonToTag(false)
                  onCancel();
                }}
              >
                {requestTranslation("cancel")}
              </button>
              <button
                className="btn btn-lg btn-primary"
                onClick={() => {
                  // setPhenomenonToTag(false)
                  setFieldValue('lead', sanitizeWysiwyg(values.lead));
                  setFieldValue('body', sanitizeWysiwyg(values.body));
                  
                  setFieldValue('title', stripAllHtml(values.title));
                  setFieldValue('shortTitle', stripAllHtml(values.shortTitle));
                  setFieldValue('video', stripAllHtml(values.video));
                  setFieldValue('stazonChart', stripAllHtml(values.stazonChart));
                  setFieldValue('videoText', stripAllHtml(values.videoText));
                  setFieldValue('newsFeedInput', stripAllHtml(values.newsFeedInput));
                  
                  handleSubmit();
                }}
                type="submit"
                disabled={isSubmitting || !isValid}
              >
                {requestTranslation("update")}
              </button>
            </ButtonsContainer>
          </div>
          <ErrorModal 
            errors={errorsList} 
            onClose={handleClearErrors} 
          />
          </>
        );
      }}
    </Formik>
    
    </>
  );
};

export const DropdownValue = styled.span`
  font-size: 16px;
`;

export const Dropdown = styled.div`
  -webkit-appearance: none;
  &:after {
    display: none;
  }
`;

const Textarea = styled.textarea`
  font-size: 16px;
  min-height: 150px;
  border-radius: 1px;
`;

const RadarImageCloseContainer = styled.div`
  position: absolute;
  top: -15px;
  right: -15px;
  border-radius: 50%;
  background-color: #f1f3f3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid gray;
  &:hover {
    cursor: pointer;
  }
`;

const RadarImageClose = styled.i`
  /*color: gray;*/
  opacity: 0.7;
`;

const DeleteRowButton = styled.button`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid red;
  color: red;
  font-size: 16px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;

const CloseIcon = styled.i`
  font-size: 14px;
  font-weight: 700;
  &:hover {
    cursor: pointer;
  }
`;

const RelatedPhenomena = styled.div`
  height: 300px;
  display: flex;
  flex-direction: column;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const InformationIcon = styled(InfoCircle)`
  background-color: ${(props) =>
    props.background ? "#f1f3f3" : "transparent"};
  color: #666;
  width: 18px;
  height: 18px;
  margin-top: 65px;
  margin-bottom: 14px;
  margin-left: 18px;
  &:hover {
    cursor: pointer;
    color: #64cdef;
  }
`;

PhenomenonEditForm.propTypes = {
  // phenomenon: PropTypes.object,
  // radar: PropTypes.shape({
  //     id: PropTypes.string.isRequired,
  //     groupId: PropTypes.number.isRequired,
  //     language: PropTypes.string.isRequired
  // }),
  // onDelete: PropTypes.func.isRequired,
  // onCancel: PropTypes.func.isRequired,
  // onSubmit: PropTypes.func.isRequired
};
